import {
  CacheUpdateEvent,
  CacheDeleteEvent,
} from '@/rec-cache/rec-cache-events'

class IndexSelection {
  constructor(index, ids, refreshFn) {
    console.log(
      'rec-cache.index-selector.index-selector.constructor',
      index,
      ids
    )
    // TODO if the selection is created dynamically, ie after some individuals have been indexed, the selection is empty until query is called.
    // Rather the selection should be set to the index and the refresh function called.
    this._selection = []
    this.index = index
    this.ids = ids
    this.text = null
    this.texts = []
    this.refreshFn = refreshFn
  }

  // TODO consider if a set rather than array shall be returned.
  get selection() {
    return this._selection
  }

  clear() {
    this._selection = []
    if (this.refreshFn) this.refreshFn(this._selection)
  }

  query(text) {
    console.log('rec-cache.index-selector.state.query', text)
    if (!text) {
      this._selection = [...this.ids.values()]
      this.text = null
      this.texts = []
      if (this.refreshFn) this.refreshFn(this._selection)
      return this._selection
    }
    if (this.text == text) return this._selection

    this.texts = text
      .toLowerCase()
      .split(' ')
      .filter((w) => !!w.length)

    // Time the different parts. Use random label for timer.
    // The by far longest step is the filtering of the ids.
    // For the first letter (eg 'r') the list of ids comrpises ~16000 elementsd as duplicates is not removed until later
    // Try to create a Set with the id per string which should leave the list significantly shortetr
    // Addiitonally, if only one text is tested it shouldn bet necessary to do the logical and step with previous list

    const label = Math.random().toString(36).substring(2, 10)

    console.time(label)

    let matches = [...this.ids.values()]
    console.log('matches', matches.length)

    console.timeLog(label)
    this.texts.forEach((t) => {
      console.log('keys')
      let interim = [...this.index.keys()]
      console.timeLog(label)
      console.log('filter keys')

      interim = interim.filter((k) => k.includes(t))
      console.log('hits', interim.length)
      console.timeLog(label)
      console.log('map')

      interim = interim.map((k) => this.index.get(k))
      console.timeLog(label)
      console.log('reduce')

      const uniqueIds = new Set()
      interim.forEach((ids) => ids.forEach((id) => uniqueIds.add(id)))
      console.log('unique ids', uniqueIds.size)
      console.timeLog(label)

      // interim = interim.reduce((a, v) => a.concat(v), [])
      // console.timeLog(label)
      // console.log('filter ids', interim.length)

      matches = matches.filter((id) => uniqueIds.has(id))
      // matches = interim.filter(id => matches.includes(id))
      console.timeLog(label)

      // matches = [...this.index.keys()]
      //   .filter(k => k.includes(t))
      //   .map(k => this.index.get(k))
      //   .reduce((a, v) => a.concat(v), [])
      //   .filter(id => matches.includes(id))
    })
    console.timeLog(label)

    // TODO test for reactivity as array asignment to reactive component doesnt work...
    this._selection = [...new Set(matches)]
    // this._selection.splice(0, this._selection.length, ...new Set(matches))
    console.timeLog(label)

    if (this.refreshFn) this.refreshFn(this._selection)

    return this._selection
  }

  update(id, strings) {
    // console.log('rec-cache.index-selector.index-selection.update', id)

    // Algorithm
    // If individual already in selection and it shall be in selection, do nothing.
    // If individual not in selection, and it shall not be in selection, do nothing.
    // If individual already in selection, and it shall not be in selection, remove and refresh.
    // If individual not in selection, and it shall be in selection, add and refresh.

    const inSelection = this._selection.includes(id)
    const shallBeIn =
      this.texts.filter((t) => strings.find((s) => s.includes(t))).length ==
      this.texts.length

    if (inSelection && !shallBeIn) {
      this._selection = this._selection.filter((i) => i != id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
    if (!inSelection && shallBeIn) {
      this._selection.push(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }

  add(id, strings) {
    if (
      this.texts.filter((t) => strings.find((s) => s.includes(t))).length ==
      this.texts.length
    ) {
      this._selection.push(id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }

  delete(id) {
    if (this._selection.includes(id)) {
      this._selection = this._selection.filter((i) => i != id)
      if (this.refreshFn) this.refreshFn(this._selection)
    }
  }
}

// TODO the databases argument must be specified further. Injected from RecCache.
class IndexSelector {
  constructor(dbs) {
    console.log('rec-cache.index-selector.index-selector.constructor', dbs)

    this._states = []
    this.ids = dbs.ids
    // The index maps string to array of id values.
    // The indexed ids are a set of id values.
    this.index = new Map()
    this.indexedIds = new Set()

    // TODO mount update event...
    addEventListener(CacheUpdateEvent, this.update.bind(this))
    addEventListener(CacheDeleteEvent, this.delete.bind(this))
  }

  clear() {
    this.index.clear()
    this.indexedIds.clear()

    this._states.forEach((s) => s.clear())
  }

  // Event handler for cache update event. Individual may be either added or updated in the cache.
  // TODO consider if the cache shall issue two different events, would likely make sense.
  // Parameter individual is a RecIndividual.
  update({ detail: individual }) {
    const id = individual.id.value
    const isUpdate = this.indexedIds.has(id)
    if (isUpdate) {
      // The individual has already been indexed prior and all strings are removed before being re-added.
      // TODO implement... consider if an add and an update and an delete event shall be issued from cache...
      // TODO crude implementation. Consider alternatives and refactor.
      // First identify all changes, then apply. Unclear if manipulations can be undertaken through for each.
      const changes = new Map()
      this.index.forEach((values, key) => {
        const ids = values.filter((v) => v != id)
        changes.set(key, ids)
      })
      changes.forEach((values, key) => {
        if (values.length) this.index.set(key, values)
        else this.index.delete(key)
      })
    }

    // Add values to index; the id itself, the types and the property values.
    const strings = [
      individual.id.value,
      ...individual.types.map((t) => t.value),
      ...individual.properties
        .map((p) => p.values)
        .reduce((a, v) => a.concat(v), [])
        .map((v) => v.value),
    ]
      .map((s) => s.toLowerCase())
      .filter((s) => !!s.length)

    // console.log('rec-cache.index-selector.update.strings', strings)

    strings.forEach((s) => {
      if (this.index.has(s)) {
        this.index.get(s).push(id)
      } else {
        this.index.set(s, [id])
      }
    })

    this.indexedIds.add(id)

    this._states.forEach((s) =>
      isUpdate ? s.update(id, strings) : s.add(id, strings)
    )
  }

  delete({ detail: id }) {
    // Remove the id from the index.
    // TODO crude implementaiton, may be accelerated by finding all strings in the individual to delete,
    // and only manipulate those in the index map.
    const stringsToDelete = []
    this.index.forEach((ids, string) => {
      if (ids.includes(id)) {
        if (ids.length > 1) {
          this.index.set(
            string,
            ids.filter((i) => i != id)
          )
        } else {
          stringsToDelete.push(string)
        }
      }
    })
    stringsToDelete.forEach((s) => this.index.delete(s))

    // Remove id from indexed ids.
    this.indexedIds.delete(id)

    // Delete from selections.
    this._states.forEach((s) => s.delete(id))
  }

  // Factory for the Selection.
  // Parameter refreshFn is a function that if set is called whenever the selection changes.
  // refreshFn is called with array of ids.
  createSelection(refreshFn = null) {
    const selection = new IndexSelection(this.index, this.ids, refreshFn)
    this._states.push(selection)
    return selection
  }
}

export { IndexSelector }
